import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { cn } from "utils/cn";
import { ROUTES } from "utils/constants";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/AlertDialog";
import Button from "components/Button";

import { ReactComponent as PriorityHigh } from "assets/priority_high.svg";

import type { CancelReportTemplateDialogProps } from "./CancelReportTemplateDialog.types";

export default function CancelReportTemplateDialog({ open, setOpen }: CancelReportTemplateDialogProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const form = useFormContext();

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div
            className={cn(
              "w-20 h-20 m-auto mb-5  rounded-full flex items-center justify-center bg-general-orange-700 border border-general-orange-800",
            )}
          >
            <PriorityHigh className="w-16 h-16 fill-general-orange-900" />
          </div>
          <AlertDialogTitle className="text-center">
            {t("profile.reportTemplate.cancelReportTemplateDialog.title")}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {t("profile.reportTemplate.cancelReportTemplateDialog.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="secondary"
            className="w-full md:flex-1"
            onClick={() => navigate(ROUTES.PROFILE_REPORT_TEMPLATES, { replace: true })}
          >
            {t("button.cancelWithoutSaving")}
          </Button>
          <Button
            form="report-template-form"
            type="submit"
            className="w-full md:flex-1"
            onClick={() => !form.formState.isValid && setOpen(false)}
          >
            {t("button.save")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
